export default __webpack_public_path__ + "static/media/logo.a730f594.jpg";